// Window.clarity is declared by @nuxt/scripts (dist/runtime/registry/clarity.d.ts),
// which reaches the program via .nuxt/imports.d.ts re-exporting useScriptClarity.
// Do NOT re-declare it here: as of @nuxt/scripts 1.3.8 that global is a direct
// property on Window rather than inherited via `interface Window extends ClarityApi`,
// so a second declaration is a duplicate and fails typecheck with TS2717.
//
// The conflict predates 1.3.8 -- under the `extends` form TypeScript raised TS2430
// against lib.dom.d.ts instead, which `skipLibCheck: true` (.nuxt/tsconfig.json) hid.
// 1.3.8 only moved where the error is reported, out of a lib file and into this one.

if (import.meta.client) {
  // In case Clarity is not yet loaded (or never will be) we create a queue so Clarity can pick it up, or never pick it up if it's missing
  // Cast: this placeholder only needs to buffer calls into `q` until the real
  // snippet replaces it; it does not implement the full typed Clarity surface.
  window.clarity = window.clarity || (function (...args: unknown[]) {
    (window.clarity.q = window.clarity.q || []).push(args)
  } as unknown as Window['clarity'])
}

export const identify = (userId: string | undefined | null, params: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.clarity && userId) {
    // Identify the user
    window.clarity('identify', userId)

    // Set custom session tags for each param (Clarity uses 'set' for custom data)
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        window.clarity('set', key, String(value))
      }
    })
  }
}

// Clarity custom tag marking a session that ENTERED the site through a
// demonstrator attribution link the backend accepted - the cart ended up with
// that demonstrator. A link naming an unknown or ineligible demonstrator is not
// tagged. The value is the attribution param that referred it, which keeps the
// tag low-cardinality (3 possible values) while still showing which link format
// is still in use. AB#63131
export const DEMO_REFERRAL_TAG = 'demoReferral'

export const setTag = (key: string, value: string | null | undefined) => {
  if (typeof window !== 'undefined' && window.clarity && value) {
    window.clarity('set', key, String(value))
  }
}

// Tags the session, then clears the marker so only the entry session carries
// the tag rather than every subsequent page view.
export const emitDemoReferralTag = (value: string | null | undefined, clear: () => void) => {
  if (!value) { return }
  setTag(DEMO_REFERRAL_TAG, value)
  clear()
}
